import IiconProps from "../../constants/iconProp";

const IWalkingSteps = (props: IiconProps) => {
  const { width = "22", height = "22", style } = props;
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.8 15.4406L17.675 14.9344C17.85 12.3188 16.3625 9.1125 16.625 6.4125C16.8875 2.95312 18.725 0.675 21.4375 0.84375C23.975 1.0125 25.6375 3.62812 25.2875 7.93125C25.025 12.0656 23.8 15.4406 23.8 15.4406Z"
        stroke="#363435"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M20.125 22.7813C18.4625 22.6125 17.15 21.2625 17.325 19.575L17.4125 18.3094L23.5375 18.8156L23.45 20.0812C23.3625 21.6844 21.875 22.95 20.125 22.7813Z"
        stroke="#363435"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M4.19998 18.8156L10.325 18.3094C10.0625 15.6938 11.55 12.4875 11.375 9.7875C11.025 6.24375 9.18748 4.05 6.47498 4.21875C3.93748 4.3875 2.36248 7.00313 2.71248 11.3063C3.06248 15.4406 4.19998 18.8156 4.19998 18.8156Z"
        stroke="#363435"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M7.87502 26.1563C9.53752 25.9875 10.85 24.5531 10.675 22.95L10.5875 21.6844L4.46252 22.1906L4.55002 23.4562C4.72502 25.0594 6.21252 26.2406 7.87502 26.1563Z"
        stroke="#363435"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default IWalkingSteps;
